// box_selector_controller.js
import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    // Define targets: we need to identify all the "box" buttons.
    // The 'boxes' target will be an array of all elements with data-box-selector-target="box".
    static targets = ["box"];

    connect() {
        console.log("Box Selector Stimulus Controller connected! 📦");
    }

    /**
     * Sets the clicked box as active and deactivates others.
     * This method will be called when a box button is clicked.
     * @param {Event} event The click event.
     */
    select(event) {
        const clickedBox = event.currentTarget; // The button that was clicked

        // Remove 'active' class from all boxes
        this.boxTargets.forEach((box) => {
            box.classList.remove("active");
            // For the color box, you might want to also remove custom-ui-card-selected if it's not active
            if (box.classList.contains("custom-ui-card-selected")) {
                box.classList.remove("custom-ui-card-selected");
            }
        });

        // Add 'active' class to the clicked box
        clickedBox.classList.add("active");

        // Special handling for the color box, if it has a different active style
        // You can adjust this logic based on your exact CSS.
        if (clickedBox.querySelector(".custom-ui-color-circle")) {
            clickedBox.classList.add("custom-ui-card-selected");
        }

        // You can also get the text of the selected box
        const selectedText = clickedBox.querySelector(".custom-ui-text").textContent;
        console.log(`Selected box: ${selectedText}`);

        // If you need to perform other actions based on the selection, do it here.
        // E.g., this.dispatch('selected', { detail: { text: selectedText, element: clickedBox } });
    }

    // You can optionally add a disconnect method for cleanup if needed,
    // but for simple class toggling, it's often not strictly necessary.
    // disconnect() {
    //   console.log("Box Selector Stimulus Controller disconnected! 👋");
    // }
}